<div
  [ngStyle]="{
    border: '1px solid ' + (displayColor || DEFAULT_COLOR),
    height: SMALL_SIZE === size ? '80px' : '128px',
    width: SMALL_SIZE === size ? '80px' : '128px',
  }"
>
  <div [ngStyle]="{ padding: SMALL_SIZE === size ? '4px 0' : '8px 4px' }">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 185 128.75"
      [attr.width]="SMALL_SIZE === size ? '70px' : '90px'"
      [attr.height]="SMALL_SIZE === size ? '49px' : '63px'"
    >
      <g>
        <g id="Vector">
          <path
            id="path0_fill"
            data-name="path0 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M34.86,16.69H27V40.21H21.41V16.69H13.58v-4.3H34.86Z"
          />
        </g>
        <g id="Vector-2" data-name="Vector">
          <path
            id="path1_fill"
            data-name="path1 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M42,40.65a9.33,9.33,0,0,1-7.15-2.87,10.26,10.26,0,0,1-2.67-7.28v-.76a11.31,11.31,0,0,1,2.53-7.59,8.43,8.43,0,0,1,6.79-3A8.38,8.38,0,0,1,48,21.71a9.71,9.71,0,0,1,2.31,6.82v3H38l0,.12A5.38,5.38,0,0,0,39.28,35a4.27,4.27,0,0,0,3.29,1.31A11.08,11.08,0,0,0,45.65,36a13.92,13.92,0,0,0,2.68-1.18l1.5,3.45A10.42,10.42,0,0,1,46.53,40,14.49,14.49,0,0,1,42,40.65Zm-.5-17.16A2.91,2.91,0,0,0,39,24.67a6.17,6.17,0,0,0-1.11,3.12l0,.09h6.85v-.49A4.45,4.45,0,0,0,44,24.55,3,3,0,0,0,41.48,23.49Z"
          />
        </g>
        <g id="Vector-3" data-name="Vector">
          <path
            id="path2_fill"
            data-name="path2 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M58.64,19.57l.25,3a7.54,7.54,0,0,1,2.54-2.46,6.53,6.53,0,0,1,3.38-.88,6.22,6.22,0,0,1,4.89,2q1.76,2,1.76,6.17V40.25h-5.6V27.32a4.21,4.21,0,0,0-.84-3,3.38,3.38,0,0,0-2.54-.87,4.32,4.32,0,0,0-2,.45A4.09,4.09,0,0,0,59,25.21v15H53.44V19.57Z"
          />
        </g>
        <g id="Vector-4" data-name="Vector">
          <path
            id="path3_fill"
            data-name="path3 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M34.94,56.09H27.07V79.61H21.49V56.09H13.65v-4.3H34.94Z"
          />
        </g>
        <g id="Vector-5" data-name="Vector">
          <path
            id="path4_fill"
            data-name="path4 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M41.85,61.54a7.19,7.19,0,0,1,2.39-2.21,6.28,6.28,0,0,1,3.13-.79,6.36,6.36,0,0,1,5.08,2.15c1.22,1.44,1.84,3.65,1.84,6.64V79.6H48.71V67.26a5.3,5.3,0,0,0-.85-3.41,3.13,3.13,0,0,0-2.53-1,4.81,4.81,0,0,0-2,.41,3.93,3.93,0,0,0-1.45,1.16V79.6H36.27V49.79h5.58V61.54Z"
          />
        </g>
        <g id="Vector-6" data-name="Vector">
          <path
            id="path5_fill"
            data-name="path5 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M56.47,69.12a11.11,11.11,0,0,1,2.58-7.58,9,9,0,0,1,7.15-2.95,9.07,9.07,0,0,1,7.18,2.94A11,11,0,0,1,76,69.12v.4a11.05,11.05,0,0,1-2.59,7.6,9,9,0,0,1-7.15,2.93,9.1,9.1,0,0,1-7.18-2.93,11.05,11.05,0,0,1-2.59-7.6v-.4Zm5.56.39A8.89,8.89,0,0,0,63,74a3.43,3.43,0,0,0,3.21,1.71A3.39,3.39,0,0,0,69.4,74a8.88,8.88,0,0,0,1-4.52v-.4a8.74,8.74,0,0,0-1-4.48,3.42,3.42,0,0,0-3.19-1.74A3.38,3.38,0,0,0,63,64.63a8.92,8.92,0,0,0-1,4.48Z"
          />
        </g>
        <g id="Vector-7" data-name="Vector">
          <path
            id="path6_fill"
            data-name="path6 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M90.87,76.68a6.87,6.87,0,0,1-2.42,2.51A7.15,7.15,0,0,1,80,78c-1.22-1.39-1.84-3.56-1.84-6.5V59h5.56V71.53a5.37,5.37,0,0,0,.77,3.25,2.65,2.65,0,0,0,2.25,1A5.47,5.47,0,0,0,89,75.33a3.82,3.82,0,0,0,1.57-1.27V59h5.58V79.67H91.37Z"
          />
        </g>
        <g id="Vector-8" data-name="Vector">
          <path
            id="path7_fill"
            data-name="path7 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M110.33,74a1.92,1.92,0,0,0-.89-1.58,9.05,9.05,0,0,0-3.29-1.19,13.31,13.31,0,0,1-5.54-2.2,4.82,4.82,0,0,1-1.86-4A5.71,5.71,0,0,1,101,60.45a9.11,9.11,0,0,1,6-1.86,9.89,9.89,0,0,1,6.29,1.85,5.5,5.5,0,0,1,2.25,4.68l0,.12h-5.39a2.74,2.74,0,0,0-.79-2,3.81,3.81,0,0,0-4.45-.12,2.07,2.07,0,0,0-.78,1.65,1.89,1.89,0,0,0,.81,1.57,9,9,0,0,0,3.3,1.09,13.49,13.49,0,0,1,5.68,2.24,5,5,0,0,1,1.85,4.08,5.45,5.45,0,0,1-2.39,4.56,10.32,10.32,0,0,1-6.3,1.77A9.61,9.61,0,0,1,100.52,78a5.85,5.85,0,0,1-2.28-4.77l0-.12h5.11a2.88,2.88,0,0,0,1.09,2.41,4.44,4.44,0,0,0,2.69.75,3.86,3.86,0,0,0,2.36-.62A2,2,0,0,0,110.33,74Z"
          />
        </g>
        <g id="Vector-9" data-name="Vector">
          <path
            id="path8_fill"
            data-name="path8 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M130.69,79.65a11.36,11.36,0,0,1-.52-1.49,10.67,10.67,0,0,1-.32-1.61,7.77,7.77,0,0,1-2.26,2.51,5.7,5.7,0,0,1-3.36,1,7,7,0,0,1-5-1.67,6,6,0,0,1-1.76-4.56,5.44,5.44,0,0,1,2.34-4.71c1.56-1.12,3.84-1.67,6.83-1.67h3.12V65.79a3.23,3.23,0,0,0-.79-2.31,3.65,3.65,0,0,0-4.4-.16,2.33,2.33,0,0,0-.74,1.82l-5.39,0,0-.11a5.24,5.24,0,0,1,2.28-4.52,9.87,9.87,0,0,1,6.32-1.9,9.26,9.26,0,0,1,6,1.88,6.54,6.54,0,0,1,2.31,5.36v8.55a17,17,0,0,0,.22,2.73,13.92,13.92,0,0,0,.7,2.54Zm-5.1-3.73a4.82,4.82,0,0,0,2.62-.72,3.86,3.86,0,0,0,1.55-1.69V70.59h-3.12a3.73,3.73,0,0,0-2.69.89,2.89,2.89,0,0,0-.92,2.15,2.14,2.14,0,0,0,.69,1.66A2.66,2.66,0,0,0,125.59,75.92Z"
          />
        </g>
        <g id="Vector-10" data-name="Vector">
          <path
            id="path9_fill"
            data-name="path9 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M142.65,59l.25,3a7.64,7.64,0,0,1,2.54-2.46,6.56,6.56,0,0,1,3.38-.88,6.22,6.22,0,0,1,4.89,2q1.75,2,1.76,6.17V79.65h-5.6V66.72a4.21,4.21,0,0,0-.84-3,3.38,3.38,0,0,0-2.54-.87,4.32,4.32,0,0,0-2,.45A4.19,4.19,0,0,0,143,64.62v15h-5.58V59Z"
          />
        </g>
        <g id="Vector-11" data-name="Vector">
          <path
            id="path10_fill"
            data-name="path10 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M156.45,69.43a13.41,13.41,0,0,1,2.11-7.89,6.86,6.86,0,0,1,5.95-3,5.73,5.73,0,0,1,2.79.67,6.68,6.68,0,0,1,2.18,1.91V49.79h5.6V79.6h-4.79l-.46-2.52a6.79,6.79,0,0,1-2.31,2.17,6.06,6.06,0,0,1-3,.75,7,7,0,0,1-5.92-2.79,11.91,11.91,0,0,1-2.11-7.38Zm5.56.41a8.49,8.49,0,0,0,.92,4.29,3.17,3.17,0,0,0,3,1.57,4.29,4.29,0,0,0,2.1-.49,3.8,3.8,0,0,0,1.47-1.43V64.92A4.22,4.22,0,0,0,168,63.39a3.81,3.81,0,0,0-2.07-.55,3.14,3.14,0,0,0-3,1.83,10.35,10.35,0,0,0-1,4.76Z"
          />
        </g>
        <g id="Vector-12" data-name="Vector">
          <path
            id="path11_fill"
            data-name="path11 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M35.4,109.94l0,.11a9.06,9.06,0,0,1-2.74,7.13q-2.82,2.64-7.83,2.64a10.88,10.88,0,0,1-8.16-3.23,11.44,11.44,0,0,1-3.13-8.31v-5.53a11.65,11.65,0,0,1,3-8.31,10.41,10.41,0,0,1,8-3.25q5.16,0,8.07,2.65a9,9,0,0,1,2.82,7.21l0,.12H30A6.1,6.1,0,0,0,28.69,97a5.25,5.25,0,0,0-4.1-1.46,4.67,4.67,0,0,0-4,2,8.66,8.66,0,0,0-1.47,5.19v5.55a8.37,8.37,0,0,0,1.55,5.22,5,5,0,0,0,4.18,2,4.9,4.9,0,0,0,3.87-1.41A6.06,6.06,0,0,0,30,109.94Z"
          />
        </g>
        <g id="Vector-13" data-name="Vector">
          <path
            id="path12_fill"
            data-name="path12 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M36.92,108.92a11.11,11.11,0,0,1,2.58-7.58,9,9,0,0,1,7.15-3,9.09,9.09,0,0,1,7.18,2.94,11,11,0,0,1,2.6,7.59v.4a11.1,11.1,0,0,1-2.59,7.6,9.07,9.07,0,0,1-7.16,2.93,9.08,9.08,0,0,1-7.17-2.93,11.05,11.05,0,0,1-2.59-7.6v-.4Zm5.56.39a9,9,0,0,0,1,4.53,3.45,3.45,0,0,0,3.21,1.71,3.4,3.4,0,0,0,3.17-1.72,8.88,8.88,0,0,0,1-4.52v-.4a8.91,8.91,0,0,0-1-4.49,3.44,3.44,0,0,0-3.19-1.73,3.4,3.4,0,0,0-3.17,1.74,8.92,8.92,0,0,0-1,4.48Z"
          />
        </g>
        <g id="Vector-14" data-name="Vector">
          <path
            id="path13_fill"
            data-name="path13 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M78.06,94.29a2.68,2.68,0,0,1,2.06-.74,9.51,9.51,0,0,1,1,0l.89.14.48-4.15q-.88-.2-1.62-.3a10.16,10.16,0,0,0-1.44-.1,8,8,0,0,0-5.64,1.88,7,7,0,0,0-2,5.36v2.3H64.55v-2.3a3,3,0,0,1,.7-2.14,2.72,2.72,0,0,1,2.06-.74,7.36,7.36,0,0,1,1,.06c.29,0,.58.08.89.13l.48-4.15c-.59-.12-1.13-.22-1.62-.29a10.19,10.19,0,0,0-1.44-.11A8,8,0,0,0,61,91.07a7,7,0,0,0-2,5.36v2.3H55.9v3.91H59V119.4h5.58V102.64h7.24V119.4h5.58V102.64h4.11V98.72H77.37V96.43A3,3,0,0,1,78.06,94.29Z"
          />
        </g>
        <g id="Vector-15" data-name="Vector">
          <path
            id="path14_fill"
            data-name="path14 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M91.52,119.85A9.33,9.33,0,0,1,84.37,117a10.26,10.26,0,0,1-2.67-7.28v-.76a11.31,11.31,0,0,1,2.53-7.59,9.44,9.44,0,0,1,13.29-.44,9.71,9.71,0,0,1,2.31,6.82v3H87.49l0,.12a5.35,5.35,0,0,0,1.36,3.35,4.29,4.29,0,0,0,3.3,1.31,10.72,10.72,0,0,0,3.08-.37A14.13,14.13,0,0,0,97.86,114l1.51,3.45a10.22,10.22,0,0,1-3.3,1.72A14.49,14.49,0,0,1,91.52,119.85ZM91,102.69a2.88,2.88,0,0,0-2.44,1.18A6.17,6.17,0,0,0,87.47,107l0,.09h6.85v-.49a4.45,4.45,0,0,0-.84-2.84A3,3,0,0,0,91,102.69Z"
          />
        </g>
        <g id="Vector-16" data-name="Vector">
          <path
            id="path15_fill"
            data-name="path15 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M111.06,119.85a9.33,9.33,0,0,1-7.15-2.87,10.26,10.26,0,0,1-2.67-7.28v-.76a11.31,11.31,0,0,1,2.53-7.59,9.44,9.44,0,0,1,13.29-.44,9.71,9.71,0,0,1,2.31,6.82v3H107l0,.11a5.33,5.33,0,0,0,1.37,3.35,4.24,4.24,0,0,0,3.29,1.32,11.08,11.08,0,0,0,3.08-.37,13.92,13.92,0,0,0,2.68-1.18l1.5,3.45a10.42,10.42,0,0,1-3.3,1.72A14.49,14.49,0,0,1,111.06,119.85Zm-.5-17.16a2.88,2.88,0,0,0-2.44,1.18A6.17,6.17,0,0,0,107,107l0,.09h6.85v-.49a4.45,4.45,0,0,0-.84-2.84A3,3,0,0,0,110.56,102.69Z"
          />
        </g>
        <g id="Vector-17" data-name="Vector">
          <path
            id="path16_fill"
            data-name="path16 fill"
            [attr.fill]="displayColor || DEFAULT_COLOR"
            d="M132.24,113.75a1.94,1.94,0,0,0-.89-1.58,9,9,0,0,0-3.3-1.19,13.12,13.12,0,0,1-5.53-2.21,4.78,4.78,0,0,1-1.86-4,5.72,5.72,0,0,1,2.24-4.54,9.13,9.13,0,0,1,6-1.86,9.9,9.9,0,0,1,6.3,1.85,5.46,5.46,0,0,1,2.24,4.68l0,.12H132a2.77,2.77,0,0,0-.79-2,3.82,3.82,0,0,0-4.46-.12,2.09,2.09,0,0,0-.77,1.65,1.89,1.89,0,0,0,.81,1.57,8.85,8.85,0,0,0,3.3,1.09,13.39,13.39,0,0,1,5.67,2.24,4.94,4.94,0,0,1,1.86,4.08,5.45,5.45,0,0,1-2.39,4.56,10.35,10.35,0,0,1-6.31,1.77,9.6,9.6,0,0,1-6.52-2.09,5.86,5.86,0,0,1-2.29-4.77l0-.12h5.1a2.91,2.91,0,0,0,1.09,2.41,4.49,4.49,0,0,0,2.7.74,3.88,3.88,0,0,0,2.36-.61A2,2,0,0,0,132.24,113.75Z"
          />
        </g>
      </g>
    </svg>
  </div>
</div>
